if(localStorage.last_visit_time != undefined){
  if((Date.now() - localStorage.last_visit_time*1) > 2*24*60*60*1000){
    localStorage.last_visit_time = Date.now();   
    localStorage.used_filter = '';
  }
}else{
  localStorage.last_visit_time = Date.now();
  localStorage.used_filter = '';
}
localStorage.scroll_deapth = 0;
document.addEventListener('DOMContentLoaded', function() {
  var refer_url = location.pathname.split('/').slice(-1)[0]?location.pathname.split('/').slice(-1)[0]:"home"
  
  document.querySelectorAll('a[href*="/collection"]:not([href^="#"]').forEach(item=>{        
      let temp_href = item.getAttribute('href').indexOf('?')>0? item.getAttribute('href') + '&internal_referral=' +  refer_url:item.getAttribute('href') + '?internal_referral=' +  refer_url;
      item.setAttribute('href',temp_href);    
  })
  document.querySelectorAll('a[href*="product"]:not([href^="#"]').forEach(item=>{
      let temp_href = item.getAttribute('href').indexOf('?')>0? item.getAttribute('href') + '&internal_referral=' +  refer_url:item.getAttribute('href') + '?internal_referral=' +  refer_url;
      item.setAttribute('href',temp_href);  
  })

  var clicked_section = '';
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.forEach((val,key)=>{
    switch(key){      
      case "section_clicked":        
        clicked_section += val+', '; 
        break;
    }  
  })
  document.querySelectorAll('#MainContent>*').forEach(item=>{
      var section_name = item.querySelector('[data-section-title]')?.getAttribute('data-section-title') || item.getAttribute('id');
      item.querySelectorAll('a[href]:not([href^="#"]').forEach(s_item=>{
        if(s_item.getAttribute('href').indexOf('?')>0){
          let temp_href = s_item.getAttribute('href') + '&section_clicked=' + clicked_section +  section_name;
          s_item.setAttribute('href',temp_href);  
        }else{
          let temp_href = s_item.getAttribute('href') + '?section_clicked=' + clicked_section +  section_name;
          s_item.setAttribute('href',temp_href);    
        }
      })
  })
   document.querySelectorAll('.j-filter-options').forEach((item)=>{
      item.addEventListener('click',function(){
        let option_val = item.getAttribute('data-type');
        if(localStorage.used_filter == ''){
            localStorage.used_filter = option_val
        }else if(localStorage.used_filter.indexOf(option_val)<0){            
            localStorage.used_filter =localStorage.used_filter+ ', '+ option_val
        }
        document.querySelectorAll('[name="properties[_used_filters]"]').forEach((i_t)=>{
          i_t.value = localStorage.used_filter;
        })
      })
    }) 

  function calculateScrollPercentage() {
      var scrollTop = window.scrollY; // Distance scrolled from the top
      var windowHeight = window.innerHeight; // Height of the viewport
      var fullHeight = document.body.scrollHeight; // Total scrollable height of the page
  
      var scrollPercentage = (scrollTop / (fullHeight - windowHeight)) * 100;
  
      return scrollPercentage;
  }
  window.addEventListener('scroll', function() {    
    var scrollPercentage = calculateScrollPercentage(); 
    if(scrollPercentage > localStorage.scroll_deapth*1){  
      localStorage.scroll_deapth = scrollPercentage.toFixed(2); 
    }      
  });
  if(document.querySelector('.sale-note-col')){
    var num = 0;
    document.querySelectorAll('.sale-note-col .multicolumn-card__info')[num].classList.add('active');
    setInterval(function(){
      num++;
      var tem = num%3;      
      document.querySelector('.sale-note-col .multicolumn-card__info.active').classList.remove('active');
      document.querySelectorAll('.sale-note-col .multicolumn-card__info')[tem].classList.add('active');
    },1200)
  }
  
})